// @flow

import React from 'react';
import { connect } from 'react-redux';
import ActiveItem from '../activeItem';
import {
  getColorLabel,
} from '../../../../../../store/configuratorSettings/selectors';
import type { Color } from '../../../../../../types/pdb';

type OwnProps = {|
  active: Color,
  price: number,
|};

type StateProps = {|
  label: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const ActiveColor = ({
  active, price, label, ...props
}: Props) => (
  <ActiveItem
    type={label}
    title={active.name}
    price={price}
    {...props}
  />
);

const mapStateToProps = (state): StateProps => ({
  label: getColorLabel(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(ActiveColor);
